import {axiosInstance} from "./base";

export const getTokenizedId = (code, idp, state) => axiosInstance.post('/api/v1/_/iamsmart/tokenized-id', {
	code, idp, state
})
